<template>
<component :is="component" v-bind="$attrs" v-for="component in components" />
</template>

<script>
export default {
  props: ["slotType"],
  inheritAttrs: false,
  data: ()=>({

  }),
  computed: {
    components() {
      return this.stores.config.config.slots[this.slotType]?.map(item=>item.component) || [];
    },
  },
  methods: {
  },

}
</script>
